import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
  useLocation
} from "react-router-dom";
import { Resizable } from 're-resizable';

import { useState, useEffect } from "react";

import {ReactComponent as Logo } from '../img/logo.svg';
import * as API from "../services/cita";

import Navigation from '../components/Navigation';

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  const citas = await API.getAllCita();
  return { citas };
}

export function CitaList(props) {
  const location = useLocation();

  return (
    <>
      <Resizable 
      id="sidebar"
      defaultSize={{
        width: 130,
      }}
      minHeight="100vh"
      maxHeight="100vh"
      >
      <div className="logo"><Logo /></div>

        {/* other code */}
      </Resizable>
      <main id="main">
      <Navigation {...props} currentUrl={location.pathname} />
        <div id="detail">
          <Outlet />
        </div>
      </main>
    </>
  );
}
